import styles from './StreamingText.module.scss'

export default function StreamingCaret() {
  return <span className={styles.caret} aria-hidden="true" />
}
